import { parseDMYToDate } from "@/utils/format-date-ddmmyyyy";
import { z } from "zod";

export const userSchema = z.object({
  store: z.string(),
  date: z.string(),
  authorizationNsu: z.string(),
  paymentValue: z.string(),
  user: z.string(),
});

export type User = z.infer<typeof userSchema>;

const DATE_REGEX_DMY =
  /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

function buildRequiredDMYDateSchema(fieldLabel: string) {
  return z
    .string({
      required_error: `${fieldLabel} é obrigatória.`,
    })
    .min(1, `${fieldLabel} é obrigatória.`)
    .refine((val) => DATE_REGEX_DMY.test(val), {
      message: "Data inválida. Use o formato dd/mm/aaaa.",
    })
    .refine((val) => {
      const selected = parseDMYToDate(val);
      if (!selected) return false;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);

      return selected <= today;
    }, {
      message: "Não é permitido selecionar uma data futura.",
    });
}

export const reversalMadeFiltersSchema = z
  .object({
    store: z.string().optional(),
    dateStart: buildRequiredDMYDateSchema("Data inicial"),
    dateEnd: buildRequiredDMYDateSchema("Data final"),
    operationType: z
      .string({
        required_error: "Tipo de operação é obrigatório.",
      })
      .min(1, "Tipo de operação é obrigatório."),
    paymentType: z
      .string({
        required_error: "Tipo de pagamento é obrigatório.",
      })
      .min(1, "Tipo de pagamento é obrigatório."),
  })
  .refine(
    (data) => {
      if (!data.dateStart || !data.dateEnd) return true;

      const start = parseDMYToDate(data.dateStart);
      const end = parseDMYToDate(data.dateEnd);

      if (!start || !end) return false;

      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      return start <= end;
    },
    {
      message: "A data inicial não pode ser maior que a data final.",
      path: ["dateEnd"],
    },
  );

export type ReversalMadeFiltersFormValues = z.infer<
  typeof reversalMadeFiltersSchema
>;